import { useTheme } from "next-themes";
import logoDark from "@/assets/logo.gif";
import logoLight from "@/assets/logo-light.gif";
import logoHorizontalDark from "@/assets/logo-horizontal.gif";
import logoHorizontalLight from "@/assets/logo-horizontal-light.gif";

interface ThemedLogoProps {
  variant?: "square" | "horizontal";
  className?: string;
  alt?: string;
}

export function ThemedLogo({ variant = "square", className, alt = "Cosmo Logo" }: ThemedLogoProps) {
  const { resolvedTheme } = useTheme();
  const isLight = resolvedTheme === "light";

  const src = variant === "horizontal"
    ? (isLight ? logoHorizontalLight : logoHorizontalDark)
    : (isLight ? logoLight : logoDark);

  return <img src={src} alt={alt} className={className} />;
}
